import { IAppState } from '../../redux';
import { selectLocationsFromAddress, selectOfferCategory } from '../offer';
import { EOfferCategory } from '../../types/reducers/offer';
import { selectConfigValue } from '../config';
import { EAgentType } from '../../redux/reducers';
import { selectIsOfferByCurrentUser } from '../offer/selectIsOfferByCurrentUser';

const SHOW_E2E_BANNER_VALID_OFFER_CATEGORIES = [
  // Продажа жилой недвижимости (Все кроме "Квартира в Новостройке")
  EOfferCategory.CottageSale,
  EOfferCategory.FlatSale,
  EOfferCategory.LandSale,
  EOfferCategory.RoomSale,
  EOfferCategory.HouseSale,
  EOfferCategory.CottageSale,
  EOfferCategory.TownhouseSale,

  // Продажа коммерческой
  EOfferCategory.OfficeSale,
  EOfferCategory.BuildingSale,
  EOfferCategory.ShoppingAreaSale,
  EOfferCategory.FreeAppointmentObjectSale,
  EOfferCategory.WarehouseSale,
  EOfferCategory.GarageSale,
];

const SHOW_E2E_BANNER_VALID_AGENT_TYPES = [EAgentType.agency, EAgentType.specialist];

export const selectIsDealSaleOfferLabelEnabled = (state: IAppState) => {
  const {
    user: { agentAccountType },
  } = state;
  const offerCategory = selectOfferCategory(state);

  const e2eExcludedRegionIds = selectConfigValue('e2eExcludedRegionIds', state);
  const e2eLabelResponse = selectConfigValue('e2eLabelResponse', state);

  const locationIds = selectLocationsFromAddress(state);

  const regionId = locationIds[0];

  return Boolean(
    selectIsOfferByCurrentUser(state) !== false &&
      e2eLabelResponse?.isFallback === false &&
      !e2eExcludedRegionIds.includes(regionId) &&
      offerCategory &&
      SHOW_E2E_BANNER_VALID_OFFER_CATEGORIES.includes(offerCategory) &&
      agentAccountType &&
      SHOW_E2E_BANNER_VALID_AGENT_TYPES.includes(agentAccountType),
  );
};
